import { onUnmounted, ref } from 'vue';

export default function useWidths(initialValues, el = document.body) {
  // track client width
  const cw = ref(el.clientWidth);

  // track frame widths
  const widths = ref(initialValues);

  // update frame widths
  const setWidths = (newValues) => {
    const values = newValues || initialValues;
    const total = values.reduce((a, b) => a + b);
    widths.value = [...values, cw.value - total].map((value) => ((value / cw.value) * 100));
  };

  // handle browser resizing
  const onResize = () => {
    cw.value = el.clientWidth;
    setWidths();
  };
  window.addEventListener('resize', onResize);
  onUnmounted(() => {
    window.removeEventListener('resize', onResize);
  });

  // handle frame resizing
  const onResized = (frames) => {
    const frameValues = [];
    for (let i = 0; i < frames.length - 1; i += 1) {
      frameValues[i] = Math.floor((frames[i].size / 100) * cw.value);
    }
    setWidths(frameValues);
  };

  // start
  setWidths();
  return {
    widths,
    setWidths,
    onResized,
  };
}
